<app-feedback-message
  [iconType]="iconType()"
  [title]="title()"
  [subtitle]="subtitle()"
  [textLines]="textLines()"
  ><div class="action">
    <goab-button size="compact" (onClick)="onClick()"
      >Go to homepage</goab-button
    >
  </div></app-feedback-message
>
